export const TRIGGER_CALENDAR_SYNC = 'TRIGGER_CALENDAR_SYNC';
export const RESET_CALENDAR_SYNC_TRIGGER = 'RESET_CALENDAR_SYNC_TRIGGER';

export const triggerCalendarSync = () => ({
    type: TRIGGER_CALENDAR_SYNC
});

export const resetCalendarSyncTrigger = () => ({
    type: RESET_CALENDAR_SYNC_TRIGGER
});

